import UsageDashboard from '~/pages/Usage/Dashboard';

export const PageGeneralUsage = () => <UsageDashboard />;
